import type React from 'react';
import { useState } from 'react';

import { EyeIcon } from 'lucide-react';

import {
	Alert,
	AlertDescription,
	Button,
	Dialog,
	DialogContent,
	DialogDescription,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '#src/app/shared/components/adminShadcn';

type Props = { messageType: string; children: React.ReactNode };

export const EmailPreviewButton: React.FC<Props> = ({ messageType, children }) => {
	const [open, setOpen] = useState(false);

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button type="button" variant="outline">
					<EyeIcon aria-hidden />
					Preview email
				</Button>
			</DialogTrigger>
			<DialogContent className="admin:max-w-2xl">
				<DialogHeader>
					<DialogTitle>Email Preview</DialogTitle>
					<DialogDescription>Visual approximation of the {messageType} email.</DialogDescription>
				</DialogHeader>
				<div className="admin:max-h-[70vh] admin:overflow-y-auto">
					<Alert variant="warning" className="admin:mb-3">
						<AlertDescription>
							This preview only reflects content you can edit in this form. It may not match the final email exactly —
							send yourself a test email to verify before sending.
						</AlertDescription>
					</Alert>
					{children}
				</div>
			</DialogContent>
		</Dialog>
	);
};
